import "./header.css";
import { useMemo, useState } from "react";
import { FiMenu } from "react-icons/fi";
import { Dropdown } from "antd";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";

export const Header = () => {
  const navigateAndScroll = useNavigateAndScroll();

  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const items = useMemo(
    () => [
      {
        key: "1",
        label: (
          <p
            style={{
              fontFamily: "Space Grotesk, sans-serif",
              fontSize: "1.02rem",
            }}
            onClick={() => navigateAndScroll("/business-intelligence", "top")}
          >
            Inteligencia de negocios
          </p>
        ),
      },
      {
        key: "2",
        label: (
          <p
            style={{
              fontFamily: "Space Grotesk, sans-serif",
              fontSize: "1.02rem",
            }}
            onClick={() => navigateAndScroll("/", "brocoly")}
          >
            Inteligencia de clientes
          </p>
        ),
      },
    ],
    []
  );

  return (
    <header className="header-wrapper" id="header">
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/header/logo-binamics.png`}
        alt="logo-empresa"
        className="logo-binamics pointer"
        onClick={() => navigateAndScroll("/")}
      />
      <span className="rutas-section">
        <p onClick={() => navigateAndScroll("/about")}>Acerca de</p>
        <Dropdown menu={{ items }} placement="bottom">
          <p>Productos</p>
        </Dropdown>
        {/* <p onClick={() => navigateAndScroll("/", "blog")}>Blog</p> */}
        <button
          className="boton-generico boton-rojo"
          style={{ borderColor: "var(--red-highlight)" }}
          onClick={() => navigateAndScroll("/demo", "top")}
        >
          Solicitar demo
        </button>
      </span>
      <span className="menu-mobile pointer">
        <FiMenu
          size={24}
          color="black"
          onClick={() => setShowMobileMenu((prevState) => !prevState)}
        />
        {showMobileMenu && (
          <div className="dropdown-menu columna">
            <p onClick={() => navigateAndScroll("/about")}>Acerca de</p>
            {/* <Dropdown
              menu={{ items }}
              placement="bottom"
              trigger={"contextMenu"}
            >
              <p>Productos</p>
            </Dropdown> */}
            <p
              style={{
                fontFamily: "Space Grotesk, sans-serif",
                fontSize: "1.02rem",
              }}
              onClick={() => navigateAndScroll("/business-intelligence", "top")}
            >
              Inteligencia de negocios
            </p>
            <p
              style={{
                fontFamily: "Space Grotesk, sans-serif",
                fontSize: "1.02rem",
              }}
              onClick={() => navigateAndScroll("/", "brocoly")}
            >
              Inteligencia de clientes
            </p>
            <button
              className="boton-generico boton-rojo"
              style={{ borderColor: "var(--red-highlight)" }}
              onClick={() => navigateAndScroll("/demo", "top")}
            >
              Solicitar demo
            </button>
          </div>
        )}
      </span>
    </header>
  );
};
